module.exports = __webpack_public_path__ + "img/238.d52724b2.png";